import type { SVGProps } from 'react';
const DawnFlagGW = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-GW_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-GW_svg__a)">
      <path fill="#1AB558" d="M0 16h22V7.467H0z" />
      <path fill="#FFD952" d="M0 7.467h22V0H0z" />
      <path fill="#E72B42" d="M0 16h8.38V0H0z" />
      <path
        fill="#262626"
        d="m4.19 9.023-1.54 1.134.585-1.841L1.7 7.176 3.6 7.173l.59-1.84.59 1.84 1.901.003-1.535 1.14.584 1.841z"
      />
    </g>
  </svg>
);
export default DawnFlagGW;
